import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RegisterSocio = () => {
  const [formData, setFormData] = useState({
    cedula: '',
    name: '',
    email: '',
    phone: '',
    address: ''
  });
  const [validated, setValidated] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);

  const { registerSocio, loading, clearErrors, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    clearErrors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);

    const { cedula, name, email, phone, address } = formData;
    const res = await registerSocio(cedula.trim(), name.trim(), email.trim(), phone.trim(), address.trim());
    if (res.success) {
      const numero = res.data?.user?.numeroSocio || '';
      setSuccessMsg(`Registro exitoso. Su número de socio: ${numero}. Use su cédula como contraseña inicial para iniciar sesión.`);
      // redirigir al login tras 3 segundos
      setTimeout(() => navigate('/login'), 3000);
    }
  };

  return (
    <div className="auth-container">
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <Card className="auth-card fade-in">
              <Card.Body>
                <div className="auth-header">
                  <h2>
                    <i className="fas fa-user-plus me-2 text-gradient"></i>
                    Registro Socio
                  </h2>
                  <p>Regístrate como socio de COPFAMI</p>
                </div>

                {error && (
                  <Alert variant="danger" className="mb-3">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    {error}
                  </Alert>
                )}

                {successMsg && (
                  <Alert variant="success" className="mb-3">
                    {successMsg}
                  </Alert>
                )}

                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-custom">Cédula</Form.Label>
                    <Form.Control
                      type="text"
                      name="cedula"
                      value={formData.cedula}
                      onChange={handleChange}
                      className="form-control-custom"
                      placeholder="Ingresa tu cédula"
                      required
                      minLength={6}
                    />
                    <Form.Control.Feedback type="invalid">La cédula es requerida y debe tener al menos 6 caracteres.</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-custom">Nombre Completo</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control-custom"
                      placeholder="Ingresa tu nombre completo"
                      required
                      minLength={2}
                      maxLength={100}
                    />
                    <Form.Control.Feedback type="invalid">El nombre debe tener entre 2 y 100 caracteres.</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-custom">Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control-custom"
                      placeholder="Ingresa tu email"
                      required
                    />
                    <Form.Control.Feedback type="invalid">Por favor ingresa un email válido.</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-custom">Teléfono</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-control-custom"
                      placeholder="Ingresa tu teléfono (opcional)"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-custom">Dirección</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      className="form-control-custom"
                      placeholder="Ingresa tu dirección (opcional)"
                    />
                  </Form.Group>

                  <div className="d-grid gap-2 mb-3">
                    <Button type="submit" className="btn-primary-custom" disabled={loading}>
                      {loading ? (
                        <>
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                          Registrando...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-user-plus me-2"></i>
                          Registrar como Socio
                        </>
                      )}
                    </Button>
                  </div>

                  <div className="text-center">
                    <p className="mb-0">
                      ¿Ya estás registrado?{' '}
                      <Link to="/login" className="text-decoration-none">Inicia sesión</Link>
                    </p>
                    <p className="mt-2 small text-muted">La cédula será su contraseña inicial.</p>
                  </div>
                </Form>
              </Card.Body>
            </Card>

            <div className="text-center mt-3">
              <small className="text-light">
                <i className="fas fa-shield-alt me-1"></i>
                Tus datos están protegidos y cifrados
              </small>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default RegisterSocio;
